import styled from '@emotion/styled'
import React from 'react'

import { LeftLinkArrowIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/LeftLinkArrowIcon'
import { RightLinkArrowIcon } from '@f-fertighaus/applications/Next/components/fertighaus/Icon/RightLinkArrowIcon'
import { WTPayload } from '@f-fertighaus/applications/Next/types/WTPayload'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'

enum ArrowDirection {
  left,
  right,
  none
}

enum TextVariant {
  normal = 400,
  bold = 700
}

interface InternalLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  href: string
  children: React.ReactNode
  arrowDirection?: ArrowDirection
  textVariant?: TextVariant
}

interface InternalLinkWithWTProps extends InternalLinkProps {
  wtPayload: WTPayload
}

export const InternalLinkWithWT = ({
  href,
  children,
  wtPayload,
  arrowDirection = ArrowDirection.right,
  textVariant = TextVariant.normal,
  style,
  target
}: InternalLinkWithWTProps) => {
  return {
    [ArrowDirection.left]: (
      <StyledAnchor
        href={href}
        onClick={() => webtrack(wtPayload)}
        textVariant={textVariant}>
        <LeftLinkArrowIcon />
        {children}
      </StyledAnchor>
    ),
    [ArrowDirection.right]: (
      <StyledAnchor
        href={href}
        onClick={() => webtrack(wtPayload)}
        textVariant={textVariant}>
        {children}
        <RightLinkArrowIcon />
      </StyledAnchor>
    ),
    [ArrowDirection.none]: (
      <StyledAnchor
        href={href}
        onClick={() => webtrack(wtPayload)}
        textVariant={textVariant}
        target={target}
        style={{ ...style }}>
        {children}
      </StyledAnchor>
    )
  }[arrowDirection]
}

InternalLinkWithWT.arrowDirection = ArrowDirection
InternalLinkWithWT.textVariant = TextVariant

const StyledAnchor = styled('a')<InternalLinkProps>`
  color: ${({ theme }) => theme.palette.text.primary};
  text-decoration: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: ${({ theme }) => theme.font.base}, -apple-system,
    BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
    'Open Sans', 'Helvetica Neue', sans-serif;
  font-weight: ${({ textVariant }) => textVariant};
  font-size: 14px;
`
